import React, { useState, useEffect } from 'react';
import { default as getCurrentBreakpoint } from "@pb/utils/getCurrentBreakpoint";
import { default as useBreakpoint } from "@pb/utils/reactHooks/useBreakpoint";
import { useGetMatchingSetAppeaser } from "../MatchingSet/helpers/useGetMatchingSet";
import MatchingSet from "../MatchingSet/MatchingSet";
import { ESalesContainerV1 } from './components/ESalesContainer';
import { PersonalizedContainerV1 } from './components/PersonalizedContainer';
import RecommendationArea from './components/RecommendationArea';
import { StyleWithContainerV1 } from './components/StyleWithContainer';
import { PraIds, InternalBrandIds } from './constants';
import { getPRAConfiguration } from './helpers';
import { getBrandComponent } from './utils/getBrandComponent';
const PersonalizedProductRecoCarousel = (props) => {
    var _a;
    const PersonalizedContainer = getBrandComponent('PersonalizedContainer') || PersonalizedContainerV1;
    const StyleWithContainer = getBrandComponent('StyleWithContainer') || StyleWithContainerV1;
    const ESalesContainer = getBrandComponent('ESalesContainer') || ESalesContainerV1;
    const breakpointState = useBreakpoint();
    const { disablecarousel = false, pratype } = props;
    const [praConfiguration, setPraConfiguration] = useState(undefined);
    const [breakpoint, setBreakpoint] = useState(null);
    useEffect(() => {
        if (pratype) {
            const normalizedPraType = pratype.toUpperCase();
            if (!praConfiguration || praConfiguration.ID !== normalizedPraType) {
                setPraConfiguration(getPRAConfiguration(normalizedPraType));
            }
        }
    }, [pratype]);
    useEffect(() => {
        if (breakpointState === getCurrentBreakpoint()) {
            setBreakpoint(breakpointState);
        }
    }, [breakpointState]);
    const { BRAND, SOURCE, ID } = praConfiguration || {};
    // haal means AI recommendations. but for the combination with SWG (style
    // with group) PRA, that exists only for the portfolio brands
    const showPersonalized = SOURCE === 'haal' ||
        (SOURCE === 'default' &&
            (BRAND === InternalBrandIds.COS ||
                BRAND === InternalBrandIds.ARKET ||
                BRAND === InternalBrandIds.MONKI));
    const showStyleWith = showPersonalized && ID === PraIds.SWG;
    const showMatchingSet = showStyleWith && InternalBrandIds.ARKET === BRAND;
    const matchingSetAppeaser = useGetMatchingSetAppeaser(props.articleid, showMatchingSet);
    if (disablecarousel || !praConfiguration || !breakpoint || matchingSetAppeaser.loading) {
        return null;
    }
    const sharedProps = Object.assign(Object.assign({}, props), { praConfiguration,
        breakpoint });
    if (!sharedProps.articledata && pratype === PraIds.SWG) {
        sharedProps.articledata = {};
    }
    if (BRAND === InternalBrandIds.STORIES) {
        return React.createElement(RecommendationArea, Object.assign({}, sharedProps));
    }
    if (showMatchingSet && ((_a = matchingSetAppeaser === null || matchingSetAppeaser === void 0 ? void 0 : matchingSetAppeaser.response) === null || _a === void 0 ? void 0 : _a.articles.length)) {
        return React.createElement(MatchingSet, { matchingSet: matchingSetAppeaser.response });
    }
    if (showStyleWith) {
        return React.createElement(StyleWithContainer, Object.assign({}, sharedProps));
    }
    if (showPersonalized) {
        return React.createElement(PersonalizedContainer, Object.assign({}, sharedProps));
    }
    return React.createElement(ESalesContainer, Object.assign({}, sharedProps));
};
export default PersonalizedProductRecoCarousel;
//# sourceMappingURL=PersonalizedProductRecoCarousel.js.map